// extracted by mini-css-extract-plugin
export default {"placeholderPreview":"Gb9dg","landscape":"RZG8f","portrait":"gdmaS","image":"EdLyJ"};